import React from 'react';
import Navbar from './Navbar';
import AgeCounter from './AgeCounter';

const HeroSection = () => {
  return (
    <header className="hero-section">
      <Navbar />
      <div className="hero-title">
        <AgeCounter />
        <h1 className="hero-title-text">$Lindy</h1>
      </div>
      {/* Mobile-only A image */}
      <img src="/A.png" alt="A Image Mobile" className="mobile-A" style={{ display: 'none' }} />
      <div className="hero-bottom-wave">
        <div style={{ width: '100%', textAlign: 'center', padding: '30px 0 0 0' }}>
          <hr style={{ border: 'none', borderTop: '3px solid var(--accent-color)', width: '100%', margin: '0 0 18px 0' }} />
          <marquee behavior="scroll" direction="left" scrollamount="18"
            style={{ fontFamily: 'var(--font-main)', fontSize: '38px', color: 'var(--text-secondary)', letterSpacing: '2px' }}>
            Lindy Lindy Lindy Lindy Lindy Lindy Lindy Lindy Lindy Lindy Lindy Lindy
            Lindy Lindy Lindy Lindy Lindy Lindy Lindy Lindy Lindy Lindy Lindy Lindy Lindy
            Lindy Lindy Lindy Lindy Lindy Lindy Lindy Lindy Lindy Lindy Lindy Lindy Lindy
          </marquee>
          <hr style={{ border: 'none', borderTop: '3px solid var(--accent-color)', width: '100%', margin: '18px 0 0 0' }} />
        </div>
      </div>
    </header>
  );
};

export default HeroSection;
